export default "__VITE_ASSET__LzLY95Ej__"